import React, {useEffect, useMemo, useState} from 'react'
import CommentListTable from './CommentListTable'
import CommentSearchContainer from './CommentSearchContainer'
import useQueryCommentList from '../../../../hooks/api/comment/useQueryCommentList'
import {ICommentList} from '../../../../apis/comment/getCommentList'
import {useNavigate, useSearchParams} from 'react-router-dom'
import {useInputCheck} from '../../../../utils/etc'
import WizPagination from '../../../../components/pagination/WizPagination'
import useDidMountEffect from '../../../../hooks/useDidMountEffect'

interface IProps {
    className?: string
}

const CommentListContainer: React.FC<IProps> = ({className}) => {
    const [searchParams] = useSearchParams(document.location.search)
    const queryKeyword = searchParams.get('keyword')
    const queryId = searchParams.get('search_id')
    const navigate = useNavigate()
    const {checkList, onCheckedFunction, resetCheckList, onChangeCheckList} = useInputCheck()
    const [searchWord, setSearchWord] = useState(queryKeyword || '')
    const [searchId, setSearchId] = useState(queryId || '')
    const [currentPage, setCurrentPage] = useState(1)
    const [searchTarget, setSearchTarget] = useState(queryKeyword ? 'comment' : queryId ? 'user' : 'comment')

    const {data, refetch} = useQueryCommentList(searchWord, currentPage, searchId)

    const commentList = useMemo(() => {
        let list: ICommentList[] = []
        data?.data?.map(item => list.push(item))
        return list
    }, [data])

    useEffect(() => {
        const currentPageParams = new URLSearchParams(window.location.search).get('page')
        setCurrentPage(Number(currentPageParams) || 1)
    }, [])

    useDidMountEffect(() => {
        if (searchId) {
            navigate(`/comment?search_id=${searchId}`)
        } else if (searchWord) {
            navigate(`/comment?keyword=${searchWord}`)
        } else if (searchWord === '' || searchId === '') {
            navigate(`/comment`)
        }
        refetch()
    }, [searchWord, searchId])

    useDidMountEffect(() => {
        setSearchWord('')
        setSearchId('')
    }, [searchTarget])

    useEffect(() => {
        refetch()
        resetCheckList()
    }, [currentPage])

    const onClickAllBanUser = () => {
        const arr = []
        commentList?.map(item => {
            if (item?.user?.is_filtered) {
                arr.push(item)
            }
        })

        onChangeCheckList(arr)
    }

    const searchList = useMemo(() => {
        return [
            {id: 'comment', value: 'Comment'},
            {id: 'user', value: 'User_ID'},
        ]
    }, [])

    return (
        <>
            <CommentSearchContainer
                checkList={checkList}
                search={searchWord || searchId}
                searchList={searchList}
                onChangeSearchTarget={e => setSearchTarget(e)}
                searchTarget={searchTarget}
                onClick={e => {
                    if (searchTarget === 'comment') {
                        setSearchWord(e)
                        setSearchId('')
                    } else {
                        setSearchId(e)
                        setSearchWord('')
                    }
                }}
                onClickAllBanUser={onClickAllBanUser}
            />
            <CommentListTable
                data={commentList}
                checkList={checkList}
                onChecked={e => onCheckedFunction(e)}
                className={'mt-[30px]'}
            />
            <WizPagination
                totalPage={data?.pageInfo?.total_count}
                currentPage={currentPage}
                onPageChange={item => {
                    setCurrentPage(item)
                    window.history.pushState('', '', `?page=${item}`)
                }}
            />
        </>
    )
}

export default CommentListContainer
